import PropTypes from "prop-types";
import React from "react";
import { useIntl } from "react-intl";
import {
  StyledReviewFieldLabelTypography,
  StyledReviewFieldStack,
  StyledReviewFieldValueTypography,
} from "../../../Styles/AccountCreation/ReviewYourInformation/ReviewYourInformationStyles";

/**
 * @description contains field labels and values.
 * @returns {ReactNode} Render the Review field labels and values.
 */
const ReviewFieldDisplay = ({ fieldLabelId, fieldData }) => {
  const intl = useIntl();
  return (
    <StyledReviewFieldStack>
      <StyledReviewFieldLabelTypography id={fieldLabelId}>
        {intl.formatMessage({
          id: fieldLabelId,
        })}
      </StyledReviewFieldLabelTypography>
      <StyledReviewFieldValueTypography id={`${fieldLabelId}-value`}>
        {fieldData}
      </StyledReviewFieldValueTypography>
    </StyledReviewFieldStack>
  );
};

ReviewFieldDisplay.propTypes = {
  fieldData: PropTypes.string.isRequired,
  fieldLabelId: PropTypes.string.isRequired,
};

export default ReviewFieldDisplay;
